import { Component, OnInit, EventEmitter, ElementRef, Input, Output, OnDestroy } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare const $: any;

@Component({
    selector: 'app-arrow-datepicker',
    templateUrl: 'arrow-datepicker.component.html',
})

export class ArrowDatepickerComponent implements OnInit, OnDestroy {
    // modeType : Page / Popup 2 종류
    // @Input() modeType: String = 'Page';
    @Input() selectOption: any = {};
    @Input() selectedValue: string;

    @Output() setTimes: EventEmitter<any> = new EventEmitter<any>();
    @Output() selectChanged: EventEmitter<any> = new EventEmitter<any>();

    startMoment: any;
    endMoment: any;
    fromDate: string;
    toDate: string;

    calendarParams: any = {
        fromDate: '',
        fromTime: '',
        toDate: '',
        toTime: ''
    };

    // 유효성 검사
    isEmptyStartTime: Boolean = false;
    isEmptyEndTime: Boolean = false;
    isInvalidTime: Boolean = false;
    invalidCnt = 0;
    diff: Number;

    isPrevVisible: Boolean = false;
    isNextVisible: Boolean = false;
    isReadOnly: Boolean = true;

    //시간선택타입
    histType: String = 'd';
    defaultHistType: String = 'd'; //현재 기준 한 달 전
    expandYN = false;

    //인터벌 타이틀
    intervalTitle = '';

    private el: HTMLElement;

    private subscription: Subscription;

    constructor(el: ElementRef,
                private translate: TranslateService ) {
        this.el = el.nativeElement;


    }

    ngOnInit() {
        /*
        this.titleTranslate();

        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.titleTranslate();
        });
        */

        // Accessing both 'this' variables in JQuery
        const _x = this;


        // invoke daterangepicker instance
        $('input[name="daterangePage"]').daterangepicker({
            //startDate: this.startMoment.startOf('day'),
            //endDate: this.endMoment.endOf('day'),
            timePicker: true,
            timePickerIncrement: 30,
            buttonClasses: 'middle button',
            applyClass: 'blue',
            cancelClass: 'darkgray',
            ranges: {
                'Today': [moment().startOf('d'), moment()],
                'Yesterday': [moment().subtract(1, 'd').startOf('days'), moment().subtract(1, 'days').endOf('day')],
                'Last 1 Hour': [moment().subtract(1, 'hour'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('M'), moment()],
                'Last Month': [moment().subtract(1, 'M').startOf('Month'), moment().subtract(1, 'Month').endOf('Month')]
            },
            locale: {
                format: 'YYYY-MM-DD',
                separator: ' ~ '
            },
            maxDate: moment()

        }, function(start, end, label) {
            console.log('New date range selected: ' + start.format('YYYY-MM-DD HH:mm') + ' to ' + end.format('YYYY-MM-DD HH:mm') + ' (predefined range: ' + label + ')');
        });


        // arrow picker 인스턴스 생성시에 parent로 start, end 시간값을 전송
        this.initializeRangeDate();


        $('input[name="daterangePage"]').on('apply.daterangepicker', function(ev, picker) {

            _x.setTimes.emit({
                fromDate: picker.startDate.format('YYYY-MM-DD'),
                fromTime: picker.startDate.format('HH:mm'),
                toDate: picker.endDate.format('YYYY-MM-DD'),
                toTime: picker.endDate.format('HH:mm')
            });

        });

    }

    ngOnDestroy() {
        //화면변경시 데이터피커가 계속붇고있어 삭제처리함.
        //div를 강제로 삭제하는 구문이나 추후 daterangepicker가 destroy하는 방법을 찾아야함..
        $('.daterangepicker').remove();

        //this.subscription.unsubscribe();
    }

    titleTranslate() {
        this.intervalTitle = this.translate.instant('MK.00201');
    }


    /*
    public setDateInterval($event) {
        this.histType = $event.target.value;

        switch (this.histType) {
            case '24':
                this.startMoment = moment().subtract(1, 'day');
                this.endMoment = moment();
                this.isPrevVisible = false;
                this.isNextVisible = false;
                this.isReadOnly = true;
                break;
            case '7':
            case '30':
            case '90':
                this.startMoment = moment().subtract(this.histType, 'day');
                this.endMoment = moment();
                this.isPrevVisible = false;
                this.isNextVisible = false;
                this.isReadOnly = true;
                break;
            case 'd':
            case 'w':
            case 'M':
            case 'y':
                this.startMoment = moment().subtract(1, this.histType).startOf(this.histType);
                this.endMoment = moment().subtract(1, this.histType).endOf(this.histType);
                this.isPrevVisible = true;
                this.isNextVisible = true;
                this.isReadOnly = true;
                break;
            case 'c':
                this.startMoment = moment();
                this.endMoment = moment();
                this.isPrevVisible = false;
                this.isNextVisible = false;
                this.isReadOnly = false;
                break;

            default:
                this.fromDate = moment(this.toDate).add(-1, type).format('YYYY-MM-DD HH:MM');
                this.toDate = moment(this.toDate).format('YYYY-MM-DD HH:MM');

                console.log('unmatched rangeType: ' + this.histType);
                break;
        }

        this.sendDateParam();

    }
    */

    /** 날짜 +,- **/
    public setDateIntervalPrevNext(sign) {

        this.startMoment = moment(this.fromDate).add(sign, this.histType);
        this.endMoment =  moment(this.toDate).add(sign, this.histType);

        if ( moment().diff(this.endMoment) < 0) {
            //this.endMoment = moment();
            this.isNextVisible = false;
        } else {
            this.isNextVisible = true;
        }

        //this.sendDateParam();
    }

    public oninput(date: string) {
        this.fromDate = date;
        // console.log('input date :' + date);
    }

    /* datepicker 유효성 체크 */
    /*
    dateValidCheck(): number {
        // 1. 초기화
        this.validCheckInit();
        // 2. 세팅
        this.setCalendarParams();
        // 3. time 유효성 체크
        this.timeRangeValidCheck(this.calendarParams.fromTime, this.calendarParams.toTime);

        if (this.invalidCnt === 0) {
            // 4. 유효성 체크
            this.dateRangeValidCheck();
        }
        return this.invalidCnt;
    }
    */

    /* 유효성값 초기화 */
    validCheckInit() {
        this.invalidCnt = 0;
        this.isEmptyStartTime = false;
        this.isEmptyEndTime = false;
        this.isInvalidTime = false;
        this.diff = 0;
    }

    /* Caller에 Date 값 전송 */
    private initializeRangeDate() {

        const startMoment: any = moment().add(-1, this.defaultHistType);
        const endMoment: any = moment();


        //change the selected date range of that picker
        $('.daterange2').data('daterangepicker').setStartDate(startMoment.format('YYYY-MM-DD'));
        $('.daterange2').data('daterangepicker').setEndDate(endMoment.format('YYYY-MM-DD'));

        // output parent component
        this.setTimes.emit({
            fromDate: startMoment.format('YYYY-MM-DD'),
            fromTime: startMoment.format('HH:mm'),
            toDate: endMoment.format('YYYY-MM-DD'),
            toTime: endMoment.format('HH:mm')
        });
    }

    /* 팝업 오픈 */
    openPopup(src: string) {
        $.magnificPopup.open({
            items: {
                src: src,
            },
        });
    }

    /* 팝업 클로즈 */
    cancel() {
        $.magnificPopup.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/arrow-datepicker/arrow-datepicker.component.ts